import api, { apiFetch, FetchResult, RequestConfig, RequestDataNoArg } from '~/helpers/api';
import { WebinarRegisterResponse } from '~/models/Webinar';

export class WebinarService {
    static register<R = WebinarRegisterResponse>(data: RequestDataNoArg, config?: RequestConfig): FetchResult<R> {
        return apiFetch(() => api.post('/api/webinar/register', data, config));
    }
}
